import { render, staticRenderFns } from "./file.overview.component.vue?vue&type=template&id=6646e1a3&scoped=true&"
import script from "./file.overview.component.vue?vue&type=script&lang=ts&"
export * from "./file.overview.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6646e1a3",
  null
  
)

export default component.exports